<script lang="ts" setup>
import { IYearMonth } from '@/coreDomainsModule/date';
import { ForecastAccuracyHeaderKey, TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import { TableContentItem } from '@/corePagesModule/BaseTableContent/interface/tableContentItems';
import TableCell from '@/corePagesModule/BaseTableContent/components/TableCell.vue';
import { ForecastAccuracyTableContentViewModel } from './forecastAccuracyTableContentViewModel';
import ForecastAccuracyRowMenu from './ForecastAccuracyRowMenu.vue';
import { computed } from 'vue';

// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerKey: ForecastAccuracyHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isBold: boolean;
    forecastStartYearMonth?: IYearMonth;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {
    forecastStartYearMonth: undefined,
  }
);

// emits
const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
  (e: 'onClickDownload', displayId: string): void;
}>();

const forecastAccuracyTableContentVM = new ForecastAccuracyTableContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

/**
 * メニュー選択時の処理
 * @param option - 選択したオプション
 */
const onSelectMenu = (option: 'download') => {
  if (option === 'download') {
    emits('onClickDownload', props.item.displayId);
  }
};
</script>

<template>
  <!-- メニュー列の場合 -->
  <TableCell
    v-if="headerKey === 'ForecastAccuracyMenu'"
    :class="[forecastAccuracyTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: forecastAccuracyTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    text-align="center"
    :table-content-property="header"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <ForecastAccuracyRowMenu @select="onSelectMenu" />
  </TableCell>
  <!-- 通常のセルの場合 -->
  <TableCell
    v-else
    :class="[forecastAccuracyTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: forecastAccuracyTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    :text-align="textAlign"
    :table-content-property="header"
    :tool-tip-value="forecastAccuracyTableContentVM.displayForecastAccuracyItem(headerKey, item, forecastStartYearMonth)"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <span class="table-cell-content" :class="{ 'table-cell-content--bold': isBold }" @click="emits('onClickNarrow')">
      {{ forecastAccuracyTableContentVM.displayForecastAccuracyItem(headerKey, item, forecastStartYearMonth) }}
    </span>
  </TableCell>
</template>

<style scoped lang="scss">
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &--bold {
    font-weight: bold;
  }
}
</style>
